import React from 'react';

import { Text } from '@yandex-360/orb-components/dist/components/Text';

import { i18n } from '../../helpers/i18n';
import Link from '../link';
import css from './index.css';

interface TermsOfUseProps {
    href: string;
}

const TermsOfUse = ({ href }: TermsOfUseProps) => {
    return (
        <Text className={css.disclaimer} typography="caption-sm-regular" color="tertiary">
            {i18n('footer', 'disclaimer') + ' '}
            <Link href={href} target="_blank" view="default" className={css.Link}>
                {i18n('footer', 'terms-of-use')}
            </Link>
        </Text>
    );
};

export default TermsOfUse;
